<template>
    <div class="equity">
        <equity-header>知识产权</equity-header>
        <div class="container">
            <!-- 知识 -->
            <section class="public">
                <div class="box">
                    <span class="title">知识</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: 'bded9ce10e944797a2d9bc3b4fa6b0df',title: '知识'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="doingList">
                    <router-link 
                        tag="li"
                        class="lis" 
                        v-for="item in lorelist" 
                        :key="item.id"
                        :to="{name: 'Detail',query:{id:item.id,mode:'ARTICLE'}}"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{ item.title }}
                            </p>
                            <p class="times">{{ item.createDate.split(' ')[0] }}</p>
                        </div>
                    </router-link>
                </ul>
            </section>
            <!-- 展示 -->
            <section class="public">
                <div class="box">
                    <span class="title">展示</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: 'f0038e58e2e44542a2b8f6492c73f986 ',title: '知识'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="videoList">
                    <router-link 
                        tag="li"
                        class="videolis" 
                        v-for="item in revealList" 
                        :key="item.id"
                        :to="{name: 'Detail',query: {id: item.id,mode: 'ARTICLE'}}"
                    >
                        <div class="icon">
                            <img :src="item.image" alt="">
                        </div>
                        <p class="words">
                            {{ item.title }}
                        </p>
                    </router-link>
                </ul>
            </section>
            <!-- 交易 -->
            <!-- <section class="public">
                <div class="box">
                    <span class="title">交易</span>
                    <span class="line"></span>
                    <span class="more">更多</span>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="busList">
                    <li class="busLis">
                        <span class="left">产品</span>
                        <span class="mid">卖方</span>
                        <span class="right">日期</span>
                    </li>
                    <li class="busLis">
                        <span class="left">沙钢物贸超薄带第二部分</span>
                        <span class="mid">江苏沙钢物资贸易有限公司</span>
                        <span class="right">2019-10-11</span>
                    </li>
                    <li class="busLis">
                        <span class="left">沙钢物贸超薄带第二部分</span>
                        <span class="mid">江苏沙钢物资贸易有限公司</span>
                        <span class="right">2019-10-11</span>
                    </li>
                    <li class="busLis">
                        <span class="left">沙钢物贸超薄带第二部分</span>
                        <span class="mid">江苏沙钢物资贸易有限公司</span>
                        <span class="right">2019-10-11</span>
                    </li>
                    <li class="busLis">
                        <span class="left">沙钢物贸超薄带第二部分</span>
                        <span class="mid">江苏沙钢物资贸易有限公司</span>
                        <span class="right">2019-10-11</span>
                    </li>
                </ul>
            </section> -->
            <!-- 保护 -->
            <section class="public">
                <div class="box">
                    <span class="title">保护</span>
                    <span class="line"></span>
                    <span class="more">更多</span>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="aegisList">
                    <li class="aegisLis">
                        <div class="aegisIcon">
                            <img src="../../assets/images/aegis_pic2.png" alt="">
                        </div>
                        <h1 class="title">山东鼎川律师事务所</h1>
                        <p class="intro">
                            山东鼎川律师事务所是经山东司法厅批准成立的一家综合性、规范化的品牌事务所。办公地点位于济南市高新区舜泰广场9号楼北楼，具备现代化的办公设施和优良的工作环境。事务所由三位资深律师共同申请开办设立，采取普通合伙的组织形式，事务所设立宗旨为“恒信、勤勉;厚德、自强”;事务所追求目标为“高起点、高素质、高标准”。事务所服务范围涵盖非诉业务、诉讼业务法律咨询和法律援助。本所自设立伊始，全休同仁便秉承办所宗旨和发展理念,始终致力于为客户提供精准的法律务，获得了业内菁遍认可和社会各界人士的广泛好评。
                        </p>
                    </li>
                    <li class="aegisLis">
                        <div class="aegisIcon">
                            <img src="../../assets/images/aegis_pic3.png" alt="">
                        </div>
                        <h1 class="title">山东华典知识产权集团</h1>
                        <p class="intro">
                            山东华典知识产权服务集团前身为山东华典商标事务所有限公司，成立于2005年1月11日，总部位于济南历下区，集团下辖山东华典知识产权服务集团有限公司天桥分公司、高新、潍坊、泰安、青岛等分公司、山东华典商标事务所有限公司、山东华典中正财务管理咨询有限公司、济南华典商贸有限公司、山东银河星座文化发展有限公司，历经十余年稳健经营和高效发展产业已遍及知识产权、财务管理、商贸、文化等多个领域。
                        </p>
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
import equityHeader from '../../components/Header';
export default {
    name: 'mall',
    components: {
        equityHeader
    },
    data() {
        return {
            lorelist: [],
            revealList: []
        }
    },
    mounted() {
        // 获取知识列表
        this.getLorelist()
        // 获取展示列表
        this.getRevealList()
    },
    methods: {
        // 获取知识列表
        getLorelist(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: 'bded9ce10e944797a2d9bc3b4fa6b0df',
                    pageNo,
                    pageSize,
                    contentType: 'ARTICLE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.lorelist = res.data.page.list
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 获取展示列表
        getRevealList(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: 'f0038e58e2e44542a2b8f6492c73f986 ',
                    pageNo,
                    pageSize,
                    contentType: 'ARTICLE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.revealList = res.data.page.list
                    console.log(this.revealList);

                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        
    },
}
</script>

<style scoped>
.equity{
    background: #F2F3F7;
} 
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
/* 知识 */
.public{
    margin-top: .2rem;
    padding: 0 .3rem;
    background: #fff;
}
.public .box{
    position: relative;
    height: .88rem;
    display: flex;
}
.public .box .title{
    font-weight: bold;
    font-size: .28rem;
    color: #D60000;
    margin-top: .3rem;
}
.public .box .line{
    width: 5.6rem;
    height: 0.02rem;
    background: #D60000;
    margin-top: .56rem;
    margin-left: auto;
}
.public .box .more{
    position: absolute;
    right: .14rem;
    color: #666;
    top: 50%;
    transform: translateY(-70%);
    padding: .1rem;
}
.public .box .bd{
    position: absolute;
    right: 0;
    top: .44rem;
}
.public .doingList {
    overflow: hidden;
}
.public .doingList .lis{
    display: flex;
    margin-bottom: .3rem;
}
.public .doingList .lis .iconBox{
    width: 1.8rem;
    height: 1.2rem;
    margin-right: .2rem;
    display: flex;
    align-items: center
}
.public .doingList .lis .iconBox img{
    width: 100%;
    max-height: 100%
}
.public .doingList .lis .rt{
    width: 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.public .doingList .lis .rt .doingTitle{
    line-height: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.public .doingList .lis .rt .times{
    color: #999;
}
/* 展示 */
.videoList{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.videolis{
    width: 3.36rem;
    height: 2.72rem;
    margin-bottom: .2rem;
}
.videoList .videolis .icon{
    width: 3.36rem;
    height: 1.9rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.videoList .videolis .icon img{
    width: 100%;
    max-height: 100%;
}
.videoList .videolis .words{
    line-height: 1.5;
    margin-top: .1rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-align: center;
}
/* 交易 */
.busList .busLis:first-child {
    font-weight: bold;
    font-size: .28rem;
}
.busList .busLis:first-child *{
    text-align: center;
}
.busList .busLis{
    display: flex;
    justify-content: space-between;
    line-height: 3;
}
.busList .busLis .left{
    width: 2.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.busList .busLis .mid{
    width: 2.6rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.busList .busLis .right{
    width: 1.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* 保护 */
.aegisList{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.aegisList .aegisLis{
    width: 3.32rem;
    height: 4.8rem;
    margin-bottom: .2rem;
}
.aegisList .aegisLis .aegisIcon{
    height: 1.76rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.aegisList .aegisLis .aegisIcon img{
    width: 100%;
}
.aegisList .aegisLis .title{
    font-size: .28rem;
    font-weight: bold;
    text-align: center;
    margin-top: .2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.aegisList .aegisLis .intro{
    line-height: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    margin-top: .1rem;
    color: #999;
}
</style>